function browserTimeZone(): string {
  try { return Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC"; }
  catch { return "UTC"; }
}

let displayTimeZone = browserTimeZone();

export function getBrowserTimeZone(): string { return browserTimeZone(); }
export function isValidTimeZone(timeZone: string): boolean {
  try { new Intl.DateTimeFormat(undefined, { timeZone }).format(); return true; }
  catch { return false; }
}
export function getDisplayTimeZone(): string { return displayTimeZone; }
export function setDisplayTimeZone(timeZone: string): void {
  try { new Intl.DateTimeFormat(undefined, { timeZone }).format(); displayTimeZone = timeZone; }
  catch { displayTimeZone = browserTimeZone(); }
}

function dateOnlyValue(value: string): boolean { return /^\d{4}-\d{2}-\d{2}$/.test(value); }

export function formatLocalDateTime(value: string | null | undefined): string {
  if (!value) return "—";
  if (value === "bootstrap" || value === "memory") return "—";
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? value : new Intl.DateTimeFormat(undefined, { timeZone: displayTimeZone, dateStyle: "medium", timeStyle: "short" }).format(date);
}

export function formatLocalDateTimeWithSeconds(value: string | null | undefined): string {
  if (!value) return "—";
  if (value === "bootstrap" || value === "memory") return "—";
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? value : new Intl.DateTimeFormat(undefined, { timeZone: displayTimeZone, dateStyle: "medium", timeStyle: "medium" }).format(date);
}

export function formatLocalDate(value: string | null | undefined): string {
  if (!value) return "—";
  const date = dateOnlyValue(value) ? new Date(`${value}T12:00:00.000Z`) : new Date(value);
  return Number.isNaN(date.getTime()) ? value : new Intl.DateTimeFormat(undefined, { timeZone: dateOnlyValue(value) ? "UTC" : displayTimeZone, dateStyle: "medium" }).format(date);
}

export function formatDateInTimeZone(value: string | Date | null | undefined, timeZone: string): string {
  if (!value) return "—";
  const date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime()) ? String(value) : new Intl.DateTimeFormat("en-CA", { timeZone, year: "numeric", month: "2-digit", day: "2-digit" }).format(date);
}

export function formatRelativeTime(value: string | null | undefined, referenceMs = Date.now()): string {
  if (!value) return "—";
  const timestamp = Date.parse(value);
  if (Number.isNaN(timestamp)) return value;
  const seconds = Math.round((referenceMs - timestamp) / 1000);
  if (seconds < 0) return "即將";
  if (seconds < 60) return "剛剛";
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return minutes + " 分鐘前";
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return hours + " 小時前";
  const days = Math.floor(hours / 24);
  if (days < 30) return days + " 天前";
  const months = Math.floor(days / 30);
  if (months < 12) return months + " 個月前";
  return Math.floor(months / 12) + " 年前";
}

export function formatProviderFailureDetails(details: Record<string, unknown> | undefined): string {
  if (!details) return "";
  const parts: string[] = [];
  if (typeof details.provider === "string") parts.push(`提供者：${details.provider}`);
  if (typeof details.capability === "string") parts.push(`能力：${details.capability}`);
  if (typeof details.httpStatus === "number") parts.push(`HTTP ${details.httpStatus}`);
  if (typeof details.retryAt === "string") parts.push(`下次重試：${formatLocalDateTime(details.retryAt)}`);
  if (details.retryAtSource === "provider") parts.push("時間來源：LUNA API");
  else if (details.retryAtSource === "retry_after") parts.push("時間來源：LUNA API Retry-After");
  else if (details.retryAtSource === "inferred_backoff") parts.push("時間來源：系統退避估算");
  if (typeof details.retryAfterSeconds === "number") parts.push(`約 ${details.retryAfterSeconds} 秒後`);
  if (typeof details.requestId === "string") parts.push(`Request ID：${details.requestId}`);
  return parts.join(" · ");
}
